var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColonRetto(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.9 45.9",
    style: {
      enableBackground: "new 0 0 48.9 45.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Component_258_1",
    transform: "translate(0.707 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20072",
    transform: "translate(-1463.119 197.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_18685"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10549",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 2,
      strokeLinejoin: "round"
    },
    d: "M1484.3-178h10.7 c3.4,0,6.1,2.8,6.1,6.2s-2.8,6.1-6.2,6.1h-5.8c-0.3,0-0.5,0.2-0.5,0.5v11.1h-5.6v-11.1c0-3.4,2.8-6.1,6.1-6.1h5.8 c0.3,0,0.5-0.2,0.5-0.5l0,0c0-0.1,0-0.3-0.1-0.3c-0.1-0.1-0.2-0.1-0.3-0.1h-10.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10549-2",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 2,
      strokeLinejoin: "round"
    },
    d: "M1479.7-183.8 c0.9-0.5,2-0.8,3-0.8c0.1,0,0.1,0,0.2,0h16c0.3,0,0.5-0.2,0.5-0.5l0,0c0-0.3-0.2-0.5-0.5-0.5l0,0h-16c-3.4,0-6.2-2.7-6.2-6.1l0,0 c0-3.4,2.7-6.2,6.1-6.2l0,0c0.1,0,0.1,0,0.2,0h27.4v5.6H1483c-0.3,0-0.5,0.2-0.5,0.5l0,0c0,0.3,0.2,0.5,0.5,0.5h16 c3.4,0,6.2,2.7,6.2,6.1l0,0c0,3.4-2.7,6.2-6.1,6.2l0,0c-0.1,0-0.1,0-0.2,0h-14.7"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 2,
      strokeLinejoin: "round"
    },
    cx: 1476.1,
    cy: -175.4,
    r: 9.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    style: {
      fill: "none",
      stroke: "#045195",
      strokeWidth: 2,
      strokeLinejoin: "round"
    },
    x1: 1469.8,
    y1: -168.7,
    x2: 1463.1,
    y2: -162
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColonRetto);
export default __webpack_public_path__ + "static/media/ColonRetto.f0980017fd4f8803911dc80ab4c43d7b.svg";
export { ForwardRef as ReactComponent };